const hasHexadecimalPattern = (input: string) => /^[0-9a-f]+$/.test(input);

export const normalizeHexColor = (value: string | undefined): string | undefined => {
    if (!value) return undefined;

    const hex = value.trim().replace(/^#/, '').toLowerCase();

    if (!hasHexadecimalPattern(hex)) return undefined;

    // We are also checking for #000f and #000000ff which are both valid CSS hexadecimal colors with alpha.
    switch (hex.length) {
        case 3:
        case 4:
            return '#' + [...hex].map((c) => c + c).join('');
        case 6:
        case 8:
            return '#' + hex;
        default:
            return undefined;
    }
};
